import { render, staticRenderFns } from "./NewWorkflowEmailModal.vue?vue&type=template&id=4d4d1a9c&scoped=true&"
import script from "./NewWorkflowEmailModal.vue?vue&type=script&lang=js&"
export * from "./NewWorkflowEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./NewWorkflowEmailModal.vue?vue&type=style&index=0&id=4d4d1a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4d1a9c",
  null
  
)

export default component.exports